import { Card, CardContent, CardHeader, CardTitle } from '../ui/card.tsx';
import { Button } from '../ui/button.tsx';
import { MessageSquare, Trash2 } from 'lucide-react';

interface AdminContactMessage { 
    id: number; 
    name: string; 
    email: string; 
    subject: string; 
    message: string; 
    created_at: string; 
}

interface MessagesTabProps {
    messages: AdminContactMessage[];
    handleDeleteMessage: (id: number) => Promise<void>;
}

export function MessagesTab({ messages, handleDeleteMessage }: MessagesTabProps) {
    return (
        <Card className="border-purple-200">
            <CardHeader>
                <CardTitle className="flex gap-2">
                    <MessageSquare className="text-purple-600"/> 
                    Mesajlar
                </CardTitle>
            </CardHeader>
            <CardContent>
                {messages.length === 0 ? (
                    <div className="text-center py-8 text-slate-500">Mesaj yok.</div>
                ) : (
                    messages.map(msg => (
                        <Card key={msg.id} className="mb-4 border-l-4 border-l-purple-500">
                            <CardContent className="p-4 flex justify-between gap-4">
                                <div>
                                    <div className="font-bold">{msg.subject}</div>
                                    <div className="text-sm text-slate-600">
                                        {msg.name} | {msg.email}
                                    </div>
                                    <div className="mt-2 text-sm bg-slate-50 p-2 rounded">
                                        {msg.message}
                                    </div>
                                </div>
                                <Button 
                                    variant="ghost" 
                                    className="text-red-500" 
                                    onClick={() => handleDeleteMessage(msg.id)}
                                >
                                    <Trash2/>
                                </Button>
                            </CardContent>
                        </Card>
                    ))
                )}
            </CardContent>
        </Card>
    );
}
